import Vue from 'vue'
import MultiLanguage from 'vue-multilanguage'
import login from './login.js'
import header from './header.js'
import tableModel from './tableModel.js'
import auditLog from './auditLog'
import reuse from './reuse'
import mainView from './mainView.js';
import userModel from './userModel.js'
import roleModel from './roleModel.js'
import changePassword from './changePassword.js'
import checkManager from './checkManager';
import reportLanguages from './report';
import managerLanguages from './manager-report';
import recordLanguages from './record'

let LanguageArr = [
    login, header, tableModel, auditLog, reuse, mainView, userModel, roleModel, changePassword, checkManager,
    ...reportLanguages, ...managerLanguages, ...recordLanguages
]

let LanguageData = {
    cn: {},
    hk: {},
    en: {},
}


let LanguageKeys = Object.keys(LanguageData);

LanguageArr.forEach((item, index) => { // 重新合并对象
    LanguageKeys.forEach((lan) => {
        let key = [Object.keys(LanguageArr[index][lan])[0]]
        LanguageData[lan][key] = LanguageArr[index][lan][key]
    })
})

// 检测翻译
let allKey = {}
let detection = (obj, LanguageKey) => {
    let keys = Object.keys(obj)
    keys.forEach((item) => {
        if (Object.prototype.toString.call(obj[item]) == "[object Object]") {
            detection(obj[item], LanguageKey)
        }
        allKey[LanguageKey]++
    })
}
LanguageKeys.forEach((item) => {
    allKey[item] = 0
    detection(LanguageData[item], item)
})

Vue.use(MultiLanguage, LanguageData)


// WEBPACK FOOTER //
// ./src/language/index.js